export const TYPE_LABELS = {
  CONSTRUCTION: 'Construction',
  SERVICE: 'Service',
  SUPPLY: 'Supply',
  MAINTENANCE: 'Maintenance',
  INSPECTION: 'Inspection',
  ENGINEERING: 'Engineering',
  OTHER: 'Other',
};

export const TYPE_OPTIONS = Object.keys(TYPE_LABELS);
